import { Component } from '@verndale/core';
declare const MktoForms2: any;

class MarketoForm extends Component {
  mutationObserver: MutationObserver;
  oberverInitialized = false;

  constructor(el: HTMLElement) {
    super(el);
    const url = this.el.dataset.formUrl;
    const instanceId = this.el.dataset.instanceId;
    const formId = this.el.dataset.formId;
    const shouldLoad = this.el.dataset.shouldLoad;
    const prefillForm = this.mapPrefill(this.el.dataset.prefillForm);

    this.mutationObserver = new MutationObserver(mutationsList => {
      const isRelevantMutation = mutationsList.some(
        mutation =>
          (mutation.type === 'childList' && mutation.addedNodes.length > 0) ||
          mutation.removedNodes.length > 0
      );

      if (isRelevantMutation) {
        this.customizeMarketoButton();
      }
    });

    if (shouldLoad === 'true') {
      MktoForms2.loadForm(url, instanceId, formId);
      MktoForms2.whenReady((form: { vals: (arg0: any) => void }) => {
        if (prefillForm) {
          form.vals(prefillForm);
        }

        this.setupDefaults();
        this.addListeners();
      });
    }
  }

  setupDefaults() {
    this.dom = {
      inputs: this.el.querySelectorAll('.mktoFieldWrap input'),
      textareas: this.el.querySelectorAll('.mktoFieldWrap textarea'),
      checkboxes: this.el.querySelectorAll(
        '.mktoLogicalField.mktoCheckboxList'
      ),
      marketoRows: this.el.querySelectorAll('.mktoFormRow'),
      button: this.el.querySelector('.mktoButtonWrap button') as HTMLElement
    };

    this.customizeMarketoButton();
    this.markTwoColumnRows();
    this.markCheckboxContainers();
    this.applyInitialInputsStyle();
  }

  addListeners() {
    const handler = this.setLabelAsPlaceholder.bind(this);
    const handleAutoComplete = this.updateLabelsForAutoComplete.bind(this);
    const events = ['focus', 'blur', 'input'];

    if (this.dom.inputs) {
      (this.dom.inputs as NodeListOf<HTMLInputElement>).forEach(input => {
        this.checkInputValue(input);
        this.addMultipleListeners(input, events, handler);
      });
    }

    if (this.dom.textareas) {
      (this.dom.textareas as NodeListOf<HTMLTextAreaElement>).forEach(
        textarea => {
          this.addMultipleListeners(textarea, events, handler);
          this.checkInputValue(textarea);
          textarea.addEventListener('input', this.resizeTextarea.bind(this));
        }
      );
    }

    document.addEventListener(
      'clearbit-forms-marketo-enrichment-complete',
      handleAutoComplete
    );
  }

  mapPrefill(data?: string) {
    const result = data ? JSON.parse(data).result : [{}];
    const response: { [key: string]: string } = {};

    if (result.length) {
      Object.keys(result[0]).forEach(key => {
        switch (key.toLowerCase()) {
          case 'firstname':
            response.FirstName = result[0][key];
            break;
          case 'lastname':
            response.LastName = result[0][key];
            break;
          case 'email':
            response.Email = result[0][key];
            break;
          case 'company':
            response.Company = result[0][key];
            break;
          case 'phone':
            response.Phone = result[0][key];
            break;
          case 'title':
            response.Title = result[0][key];
            break;
          case 'country':
            response.Country = result[0][key];
            break;
          default:
            break;
        }
      });
    }

    return response;
  }

  updateLabelsForAutoComplete() {
    const fieldWraps = Array.from(this.el.querySelectorAll('.mktoFieldWrap'));
    const inputFields = fieldWraps.filter(fieldWrap =>
      fieldWrap.querySelector('input:not([type="checkbox"])')
    );
    inputFields.forEach(field => {
      const label = field.querySelector('label');
      label?.classList.add('is-active');
    });
  }

  resizeTextarea(e: Event) {
    if (e.target) {
      const textArea = e.target as HTMLElement;
      textArea.style.height = 'auto';
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  }

  addMultipleListeners(
    element: HTMLElement,
    events: string[],
    handler: (event: Event) => void
  ) {
    events.forEach(event => element.addEventListener(event, handler));
  }

  setLabelAsPlaceholder(e: Event) {
    const input = e.target as HTMLInputElement;
    const fieldWrap = input?.closest('.mktoFieldWrap');
    const label = fieldWrap?.querySelector('label') as HTMLElement;
    if (!label) return;

    const checkboxField = fieldWrap?.closest('.checkbox-field');
    const checkboxLabel = checkboxField?.querySelector('label') as HTMLElement;
    if (checkboxLabel === label) return;

    const isTextarea = input.tagName.toLowerCase() === 'textarea';
    const isActive = input.value || input === document.activeElement;

    if (isActive) {
      if (isTextarea) label.classList.add('textarea-active');
      label.classList.add('is-active');
    } else {
      label.classList.remove('is-active');
    }
  }

  checkInputValue(input: HTMLInputElement | HTMLTextAreaElement) {
    const fieldWrap = input?.closest('.mktoFieldWrap');
    const label = fieldWrap?.querySelector('label') as HTMLElement;
    if (input.value && !fieldWrap?.closest('.checkbox-field')) {
      if (input.tagName.toLowerCase() === 'textarea') {
        label.classList.add('textarea-active');
      }

      label.classList.add('is-active');
    } else {
      label.classList.remove('is-active');
    }
  }

  customizeMarketoButton() {
    const marketoButton = this.dom.button as HTMLElement;
    console.log(marketoButton);
    if (marketoButton) {
      if (!this.oberverInitialized) {
        this.mutationObserver.observe(this.dom.button as HTMLElement, {
          childList: true,
          subtree: true
        });
        this.oberverInitialized = true;
      }

      if (marketoButton.querySelector('span')) return;

      const span = document.createElement('span');
      const buttonText = marketoButton.textContent;
      marketoButton.textContent = '';
      span.textContent = buttonText;
      marketoButton.appendChild(span);
    }
  }

  markTwoColumnRows() {
    const twoColumnRows = Array.from(
      this.dom.marketoRows as NodeListOf<HTMLElement>
    ).filter(
      (row: HTMLElement) => row.querySelectorAll('.mktoFormCol').length === 2
    );
    twoColumnRows.forEach((row: HTMLElement) =>
      row.classList.add('two-column')
    );
  }

  markCheckboxContainers() {
    (this.dom.checkboxes as NodeListOf<HTMLElement>).forEach(
      (checkbox: HTMLElement) => {
        checkbox.closest('.mktoFieldWrap')?.classList.add('checkbox-field');
      }
    );
  }

  applyInitialInputsStyle() {
    Array.from(
      this.el.querySelectorAll('.mktoFieldWrap') as NodeListOf<HTMLElement>
    )
      .filter(item => {
        return item.querySelector(
          'input[type="text"], input[type="email"], input[type="tel"], input[type="url"], input[type="number"], textarea'
        );
      })
      .forEach(item => {
        const label = item.querySelector('.mktoLabel') as HTMLElement;
        const textarea = item.querySelector('textarea') as HTMLElement;

        if (textarea) {
          label.style.paddingTop = '0';
          textarea.style.height = '40px';
        }

        label.style.insetBlockEnd = '30px';
        label.style.position = 'absolute';

        this.checkInputValue(
          item.querySelector('input, textarea') as HTMLInputElement
        );
      });

    Array.from(
      this.el.querySelectorAll('.mktoFieldWrap') as NodeListOf<HTMLElement>
    )
      .filter(item => {
        return item.querySelector('select');
      })
      .forEach(item => {
        const label = item.querySelector('.mktoLabel') as HTMLElement;
        label.style.fontSize = '12px';
      });

    if (this.dom.textareas)
      (this.dom.textareas as NodeListOf<HTMLElement>).forEach(textarea => {
        textarea.style.height = `${textarea.scrollHeight}px`;
        textarea.style.overflowY = 'hidden';
      });
  }

  public componentWillUnmount() {
    if (this.oberverInitialized) this.mutationObserver.disconnect();
  }
}

export default MarketoForm;
